module.exports = __webpack_public_path__ + "img/image01.31b1594a.jpg";